/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { Dropdown1 } from '../../content/dropdown/Dropdown1'
import { LanguageHelp } from '../../../helpers/LanguageHelper'

type Props = {
  className: string
  datas?: ListsWidget6Dto[]
}

export class ListsWidget6Dto { label = ""; url = ""; className = "d-flex align-items-center bg-light-warning rounded p-4 mb-3"; }

const ListsWidget6: React.FC<Props> = ({ className, datas = [new ListsWidget6Dto] }) => {
  return (
    <div className='card mb-5 mb-xl-8'>
      {/* begin::Header */}
      <div className='card-header border-0'>
        <h3 className='card-title fw-bold text-dark'>{LanguageHelp("Notifications")}</h3>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='scroll-y mh-150px maxh-md-225px my-5 px-8'>
        <div className='card-body p-0' style={{ minHeight: "150px" }}>
          {datas.length !== 0 && datas[0].label === "" &&
            <span className='indicator-progress' style={{ display: 'block' }}>
              {/* Please wait...{' '} */}
              <span className='spinner-border spinner-border-lg align-middle ms-2'></span>
            </span>
          }
          {!(datas.length !== 0 && datas[0].label === "") && datas.map((data, index) => (
            <div key={data.label} className={data.className}>
              <span className='svg-icon svg-icon-warning me-5'>
                <KTSVG path='/media/icons/duotune/general/gen007.svg' className='svg-icon-1' />
              </span>
              <div className='flex-grow-1 me-2'>
                {data.label}
              </div>
              {data.url !== null && data.url !== "" && (
                <a href={data.url} className='btn btn-sm btn-icon btn-active-color-primary'>
                  <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-2' />
                </a>
              )}
            </div>
          ))}
          {(datas.length === 0) && (
            <div className='text-center px-4'>
              <div>
                {LanguageHelp("Everything is fine.")}
              </div>
              <div>
                <img
                  className='mw-100 mh-100px'
                  alt='metronic'
                  src={toAbsoluteUrl('/media/illustrations/sketchy-1/1.png')}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      {/* end::Body */}

    </div>
  )
}

export { ListsWidget6 }
